define('plugin/classes/view/datetime/TimeClassesPluginItemEmptyView',['require','lib/view/LayoutView','lib/Utils'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Utils = require('lib/Utils');

    /**
     * Classes plugin item view
     *
     * @class TimeClassesPluginItemEmptyView
     */
    return LayoutView.extend({

        template: '#time_classes_plugin_item_empty_view',

        onShow: function () {
            this.$el.css({
                'top': '0px',
                'height': this.getOption('height') + '%',
                'left': this.getOption('index') * this.$el.outerWidth()
            });
        },

        serializeData: function () {
            var result = LayoutView.prototype.serializeData.apply(this);
            if (this.getOption('provider')) {
                result.provider = this.getOption('provider').toJSON();
            }
            if (this.getOption('service')) {
                result.service = this.getOption('service').toJSON();

                var toTime  = new Time(result.time);
                toTime.parseFromInteger(toTime.getInteger() + parseInt(result.service.duration));

                result.to = Date.parseMysqlDate(result.date + ' ' + toTime.getFormattedTime('24hr'));
            }
            result.time_diff = Utils.timeDiff(result, this.getOption('clientTimeZone'));
            result.label = Math.round(Math.random() * 1000);

            var waitingListHelperModel = this.getOption('waitingListHelperModel');

            result.is_wl_available_date = false;

            if(Config.getInstance().getPluginStatus('waiting_list') && waitingListHelperModel){
                result.is_wl_available_date = waitingListHelperModel.isTodayOrFutureDates() && waitingListHelperModel.isWorkDateInterval();
            }
            return result;
        }

    });

});
